export default "__VITE_ASSET__CEVizov0__"